<template>
  <a class="out-link" :href="href" target="_blank"><slot></slot></a>
</template>

<script>
export default {
  name: "OutLink",
  props: {
    href: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.out-link {
  background-image: url("@/assets/images/icons/out.svg");
  background-size: auto 0.9em;
  background-position: right 0.4em top 0.05em;
  background-repeat: no-repeat;
  padding: 0 2em 0 0;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}
</style>
